import React from 'react';
import Navigation from '../Pages/Navigation/Navigation';

const PaymentSuccess = () => {
    return (
        <div>
            <Navigation></Navigation>
            <h1 className='text-center'>payment success</h1>
        </div>
    );
};

export default PaymentSuccess;